import { render, staticRenderFns } from "./WorkorderEdit.vue?vue&type=template&id=0b1734f7&"
import script from "./WorkorderEdit.vue?vue&type=script&lang=js&"
export * from "./WorkorderEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkorderEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports